<ng-template let-entity="entity" #actionsTemplate>
  <a [routerLink]="['edit', entity.getPrimaryKey()]" i18n-ngbTooltip="@@EditUsersTooltip"
    ngbTooltip="Benutzer bearbeiten" class="btn btn-sm btn-yellow ms-1">
    <span data-bs-toggle="modal" data-bs-target="#userEdit">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="feather feather-edit">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
      </svg>
    </span>
  </a>
</ng-template>
<div class="clearfix">
  <form class="float-start">
    <div i18n="@@Search" style="min-width:200px;">
      <input class="form-control" id="table_search" type="text" name="searchTerm"
        [(ngModel)]="tableFunctions.searchTerm" i18n-placeholder="@@SearchAll" placeholder="Alles durchsuchen..." />
    </div>
  </form>
  <div class="float-end">
    <button class="btn btn-yellow" id="update_ocpp_whitelist" *ngIf="config?.isSyncWhitelistButtonVisible"
      (click)="syncWhitelistForAllUsers();" data-bs-placement="left" i18n-ngbTooltip="@@SynchronizeOCPPWhitelistTooltip"
      ngbTooltip="OCPP-Whitelist für alle Benutzer aktualisieren">
      <app-svg source="icons/feather/refresh-cw" height="18" class="me-2"></app-svg>
      <app-svg source="icons/feather/arrow-right" height="18" class="me-2"></app-svg>
      <app-svg source="icons/feather/charging-station-group" height="18"></app-svg>
    </button>
    <button *ngIf="isAddingEnabled" class="btn btn-yellow ms-2" id="add_user" [routerLink]="['create']"
      [disabled]="(entities?.length >= permissions?.manageUsersCreateCount || !permissions?.manageUsersCreate) || isSupporter"
      data-bs-placement="top">
      <app-svg source="icons/feather/user-plus" height="18"></app-svg>
      <span class="d-none d-md-inline ps-2" i18n="@@AddUserButton">Benutzer hinzufügen</span>
    </button>
  </div>
</div>
<div *ngIf="tableReady">
  <app-table [id]="className + 'Table'" [table]="table" (sorted)="onSort()"></app-table>
</div>

<div *ngIf="!tableReady" class="loading-spinner-container">
  <div class="spinner-border text-primary loading-spinner-md" role="status">
    <span class="visually-hidden-focusable" i18n="@@Loading">Loading...</span>
  </div>
</div>

<router-outlet></router-outlet>
